import {
  createProjectSchedule,
  createProjectScheduleForm,
  updateProjectSchedule,
  updateProjectScheduleForm,
} from "@/schemas/projectSchedule";
import { ulid } from "@/schemas/commonFields";
import { generateScheduleSelectedDays } from "./lib/generateScheduleSeletedDays";

export const convertCreateProjectScheduleFormToCreateProjectSchedule =
  createProjectScheduleForm
    .innerType()
    .extend({
      store_id: ulid,
      project_role_id: ulid,
    })
    .transform((value) => {
      const baseParams = createProjectSchedule.partial().parse(value);
      const dates = generateScheduleSelectedDays(value);
      return {
        ...baseParams,
        dates,
        duration: value.kam_planned_duration,
        rounding: value.rounding ?? false,
      };
    })
    .pipe(createProjectSchedule);

export const convertUpdateProjectScheduleFormToUpdateProjectSchedule =
  updateProjectScheduleForm
    .innerType()
    .extend({
      id: ulid,
      store_id: ulid,
      project_role_id: ulid,
    })
    .transform((value) => {
      const baseParams = updateProjectSchedule.partial().parse(value);
      const dates = generateScheduleSelectedDays(value);
      return {
        ...baseParams,
        dates,
        duration: value.kam_planned_duration,
        rounding: value.rounding ?? false,
      };
    })
    .pipe(updateProjectSchedule);
